import type { RouteRecordRaw } from 'vue-router'

export const errorRoutes: RouteRecordRaw[] = [
  {
    path: '/error',
    name: routeNames.error,
    component: () => import('@/views/error/Error.vue')
  }
]
